import LoadingPage from "./LoadingPage.js";
import NotFoundPage from "./NotFoundPage.js";
import ErrorPage from "./ErrorPage.js";
import Router from "juis-router/Router.js";

const dynamicImport = (path) => {
    return import(/* webpackChunkName: "[request]" */ `./${path}/index.js`);
};

/**
 * The only pages a visitor with no session can reach: the customer forms that allow it. Everything else in an app
 * needs a login (and an app that was loaded with it), so it is not routed here.
 */
export default () => {
    const router = new Router(dynamicImport, new LoadingPage(), new NotFoundPage(), new ErrorPage());
    router.setViewsBasePath("/src/hewecon/views/");
    router.addComponent(/^\/public-customer-forms\/([a-z\d\-]+)\/?/, "customer-forms/public-form");
    return router;
};
